// extracted by mini-css-extract-plugin
export default {"overlay":"AcceptInviteModal_overlay__WSkks","modal":"AcceptInviteModal_modal__0dfdN","title":"AcceptInviteModal_title__K81KG"};